import { render, staticRenderFns } from "./schema-visualizer-button.vue?vue&type=template&id=7865a8ef"
import script from "./schema-visualizer-button.vue?vue&type=script&lang=js"
export * from "./schema-visualizer-button.vue?vue&type=script&lang=js"
import style0 from "./schema-visualizer-button.vue?vue&type=style&index=0&id=7865a8ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports